import { Injectable } from '@angular/core';
import {
  CapacitorBarcodeScanner,
  CapacitorBarcodeScannerAndroidScanningLibrary,
  CapacitorBarcodeScannerTypeHint,
} from '@capacitor/barcode-scanner';
import { CrtToastController } from 'src/app/crt/providers/toast.service';

@Injectable({ providedIn: 'root' })
export class BarcodeScannerService {
  constructor(private readonly toastCtrl: CrtToastController) {}

  async scanCode(): Promise<string | undefined> {
    try {
      const result = await CapacitorBarcodeScanner.scanBarcode({
        hint: CapacitorBarcodeScannerTypeHint.ALL,
        android: { scanningLibrary: CapacitorBarcodeScannerAndroidScanningLibrary.ZXING },
      });
      return result?.ScanResult;
    } catch (error: unknown) {
      const errorCode = this.extractErrorCode(error);

      switch (errorCode) {
        case 'OS-PLUG-BARC-0006':
          //annulation du scan par l'utilisateur. On ne génère pas de toast
          break;
        case 'OS-PLUG-BARC-0007':
          this.showToast($localize`Autorisation caméra refusée`);
          break;
        case 'OS-PLUG-BARC-0008':
          this.showToast($localize`Paramètres de scan invalides`);
          break;
        case 'OS-PLUG-BARC-0013':
          this.showToast($localize`Le scanner n'est pas initialisé`);
          break;
        case 'OS-PLUG-BARC-0004':
          this.showToast($localize`Erreur lors du scan`);
          break;
        default:
          this.showToast($localize`Impossible de scanner le code`);
      }

      return undefined;
    }
  }

  private showToast(message: string) {
    this.toastCtrl.createDanger({ message, action: false, isTimed: true });
  }

  private extractErrorCode(error: unknown): string {
    if (typeof error === 'object' && error !== null && 'code' in error) {
      const code = (error as { code?: unknown }).code;
      return typeof code === 'string' ? code.toUpperCase() : '';
    }
    return '';
  }
}
